module.exports = __webpack_public_path__ + "static/img/ums-admin.422fec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/ums-admin.png
// module id = kyVR
// module chunks = 58